/* eslint-disable react/no-multi-comp */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/jsx-max-props-per-line */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { TableCell, Grid } from '@material-ui/core';
import { Table, Filtro } from '../../components';
import * as selectorsGerencias from '../../store/gerencia/reducer';
import * as actionsGerencias from '../../store/gerencia/actions';
import Formulario from './Formulario';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
}));

const Gerencias = ({ gerencias, loadGerencias, deleteGerencia }) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);
  
  const classes = useStyles();
  
  const renderRows = d => {
    return (
      <>
        <TableCell>{d.codigo}</TableCell>
        <TableCell>{d.nome}</TableCell>
        <TableCell>{d.malhaCodigo}</TableCell>
      </>
    )
  }

  useEffect(() => {
    loadGerencias()
  }, [loadGerencias]);

  const onEdit = id => {
    setOpen(true);
    setId(id);
  }

  const onDelete = id => deleteGerencia(id);
  const onAdd = () => {
    setOpen(true);
    setId(null);
  }

  const onClose = () => {
    setOpen(false);
    setId(null);
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <Filtro 
          onFilter={filterData => loadGerencias(filterData)}
          useCodigo
          useMalha
        />
      </Grid>
      <Grid item xs={12} className={classes.root}>
        <Table 
          rows={gerencias}
          titles={['Código', 'Nome', 'Malha']}
          headerTitle="Gerências"
          renderRows={renderRows}
          hasRowActions
          onEdit={onEdit}
          onDelete={onDelete}
          showDelete={false}
          onAdd={onAdd}
        />
        <Formulario
          id={id}
          open={open}
          onClose={onClose}
          gerencias={gerencias}
        />
      </Grid>
    </Grid>
  );
};

Gerencias.propTypes = {
  deleteGerencia: PropTypes.func.isRequired,
  loadGerencias: PropTypes.func.isRequired,
  gerencias: PropTypes.array,
};

const mapStateToProps = state => ({
  gerencias: selectorsGerencias.getGerencias(state),
});

const mapDispatchToProps = dispatch => bindActionCreators({
  ...actionsGerencias
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(Gerencias));